import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NavbarControlComponent } from '../../shared/controls/navbar-control/navbar-control.component';
import { IBlog } from '../../shared/models/dtos/get/blog.interface';
import { BlogService } from '../../shared/services/transactional/blog/blog.service';
import { finalize } from 'rxjs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { loadComponentTranslations } from '../../shared/funcs/lang-loader';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-blogs',
  imports: [
    FontAwesomeModule,
    TranslateModule,
    RouterModule,
    NgbDropdownModule,
    NavbarControlComponent,
  ],
  templateUrl: './blogs.component.html',
  styleUrl: './blogs.component.scss',
})
export class BlogsComponent implements OnInit {
  public isLoaded: boolean = false;
  public blogs: IBlog[] = [];

  constructor(
    private _blogService: BlogService,
    private _translateService: TranslateService,
    private _http: HttpClient,
    private metaService: Meta,
    private titleService: Title,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}
  // c
  private isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  public ngOnInit(): void {
    loadComponentTranslations(
      this._http,
      this._translateService,
      'components/blogs',
      this.isBrowser(),
    ).subscribe({
      next: () => {},
      error: () => {},
    });

    // Set the title dynamically for the blog list page
    this.titleService.setTitle('Blog - ClockFlex');

    // Set Meta Tags for SEO on the blog list page
    this.metaService.updateTag({
      name: 'description',
      content:
        'Read the latest blog posts from ClockFlex, covering time management, productivity, task tracking, and more to help businesses thrive.',
    });
    this.metaService.updateTag({
      name: 'robots',
      content: 'index, follow',
    });
    this.metaService.updateTag({
      property: 'og:title',
      content: 'Blog - ClockFlex',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content:
        'Read the latest blog posts from ClockFlex, covering time management, productivity, task tracking, and more to help businesses thrive.',
    });
    this.metaService.updateTag({
      property: 'og:image',
      content: './assets/images/blog-thumbnail.jpg', // Replace with a general blog thumbnail image
    });
    this.metaService.updateTag({
      property: 'og:url',
      content: 'https://www.clockflex.com/blog',
    });
    this.metaService.updateTag({
      name: 'twitter:title',
      content: 'Blog - ClockFlex',
    });
    this.metaService.updateTag({
      name: 'twitter:description',
      content:
        'Read the latest blog posts from ClockFlex, covering time management, productivity, task tracking, and more to help businesses thrive.',
    });
    this.metaService.updateTag({
      name: 'twitter:image',
      content: './assets/images/blog-thumbnail.jpg', // Replace with a general blog thumbnail image
    });
    this.metaService.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image',
    });

    this._blogService
      .get()
      .pipe(
        finalize(() => {
          this.isLoaded = true;
        }),
      )
      .subscribe({
        next: (response) => {
          if (response.isSuccess) {
            if (response.data && response.data.length > 0) {
              this.blogs = response.data;
            }
          }
        },
      });
  }
}
